import { render, staticRenderFns } from "./component.vue?vue&type=template&id=0e50b9ca&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=0e50b9ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50b9ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e50b9ca')) {
      api.createRecord('0e50b9ca', component.options)
    } else {
      api.reload('0e50b9ca', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=0e50b9ca&scoped=true&", function () {
      api.rerender('0e50b9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/file-download/component.vue"
export default component.exports